<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected == '库存账龄分析' ? 'selected' : ''"
        @click="toggle('库存账龄分析')"
        >库存账龄分析</span
      >
      <span>|</span>
      <span
        :class="selected == '库存账龄表' ? 'selected' : ''"
        @click="toggle('库存账龄表')"
        >库存账龄表</span
      >
    </div>

    <div v-show="selected == '库存账龄分析'">
      <div class="filter-bar">
        <span>
          {{ querytype }}
          <i class="caret"></i>
          <select
            class="filter-item__select"
            v-model="querytype"
            @change="searchBatchAgeAnalysis"
          >
            <option :value="'全部'">全部</option>
            <option :value="'物料类别'">物料类别</option>
            <option :value="'部门'">部门</option>
            <option :value="'业务员'">业务员</option>
          </select>
        </span>
      </div>
      <div class="filter-row">
        <div class="filter-info">
          <div class="filter-select">
            <mixed-inventory-aging
              label=""
              v-model="con"
              @change="searchText"
            />
          </div>
          <div class="filter-input">
            <product-field
              v-if="con == '产品'"
              label=""
              v-model="form.pr_detail"
              @select="onSelectProduct($event)"
            />
            <employee-field
              label=" "
              v-if="con == '业务员'"
              v-model="form.em_name"
              @select="onselectSeller($event)"
            />
            <department-field
              v-if="con == '部门'"
              label=""
              v-model="form.dp_name"
              @select="onSelectDepartment($event)"
            />
          </div>
        </div>
      </div>

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
        <div class="list-empty" v-if="!result.monthitems">暂无数据</div>
      </div>

      <div
        class="list-container"
        v-if="querytype == '全部' && result.monthitems"
      >
        <div class="list-fixed">
          <p class="list-box-col__title">月份</p>
          <p
            class="list-box-col__content"
            v-for="item in result.monthitems"
            :key="item.text"
          >
            {{ item.text }}
          </p>
          <p class="list-box-col__content">本年累计</p>
        </div>
        <div class="list-scroll">
          <div class="list-scroll-wrap">
            <div class="list-box-col" @click="initChart(deal2(result.details[0]))">
              <p class="list-box-col__title">{{ result.details[0].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #2eadf5"
                v-for="item in result.monthitems"
                :key="item.text"
              >
                {{ numberFormat(item.amount, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #2eadf5">
                {{ numberFormat(result.details[0].amount, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[1]))"
            >
              <p class="list-box-col__title">{{ result.details[1].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #e44959"
                v-for="item in deal2(result.details[1])"
                :key="item.text"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #e44959">
                {{ numberFormat(result.details[1].amount, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[2]))"
            >
              <p class="list-box-col__title">{{ result.details[2].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #16b603"
                v-for="item in deal2(result.details[2])"
                :key="item.text"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #16b603">
                {{ numberFormat(result.details[2].amount, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[3]))"
            >
              <p class="list-box-col__title">{{ result.details[3].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #000"
                v-for="item in deal2(result.details[3])"
                :key="item.text"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #000">
                {{ numberFormat(result.details[3].amount, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[4]))"
            >
              <p class="list-box-col__title">{{ result.details[4].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #1890ff"
                v-for="item in deal2(result.details[4])"
                :key="item.text"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #000">
                {{ numberFormat(result.details[4].amount, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[5]))"
            >
              <p class="list-box-col__title">{{ result.details[5].text }}</p>
              <p
                class="list-box-col__content"
                style="color: #1890ff"
                v-for="(item, indexs) in deal2(result.details[5])"
                :key="indexs"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #000">
                {{ numberFormat(result.details[5].amount, "#,##0.##") || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="list-cells" v-if="querytype != '全部' && result.details">
        <div
          class="list-cell"
          v-for="(item, index) in result.details"
          :key="index"
        >
          <div class="list-cell__main" @click="open(index)">
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              <p v-if="querytype == '物料类别'">{{ item.wh_product_type }}</p>
              <p v-if="querytype == '部门'">
                {{ item.pd_seller_dpname }}
              </p>
              <p v-if="querytype == '业务员'">
                {{ item.pd_sellername }}
              </p>
              <p>{{ numberFormat(item.amount, "#,##0.##") || 0 }}</p>
            </div>
            <div class="list-cell__toggle">
              <span v-if="opened == index"
                ><i class="iconfont icon-shang"></i
              ></span>
              <span v-else><i class="iconfont icon-xia"></i></span>
            </div>
          </div>
          <div class="weui-cells" v-if="opened == index">
            <div
              class="weui-cell gray"
              v-for="(month, indexs) in textArr"
              :key="indexs"
            >
              <div class="weui-cell__bd">{{ month }}</div>
              <div class="weui-cell__ft" style="font-size: 12px" v-if="indexs < 12">
                {{ numberFormat(item["amount" + (indexs+1)], "#,##0.##") || 0 }}
              </div>
              <div class="weui-cell__ft" style="font-size: 12px" v-if="indexs == 12">
                {{ numberFormat(item["amount24"], "#,##0.##") || 0 }}
              </div>
              <div class="weui-cell__ft" style="font-size: 12px" v-if="indexs == 13">
                {{ numberFormat(item["amount36"], "#,##0.##") || 0 }}
              </div>
              <div class="weui-cell__ft" style="font-size: 12px" v-if="indexs == 14">
                {{ numberFormat(item["amount99"], "#,##0.##") || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 48px" v-show="selected == '库存账龄表'">
      <search-bar
        @search="searchPurcsale"
        name=""
        placeholder="输入物料编号、名称、型号进行查找"
        ref="searchBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list2"
          :key="index"
          :to="{ name: 'StockBatchageDetail', params: { item } }"
        >
          <div class="weui-cell__bd">
            <p>{{ item.pr_detail }}</p>
            <p class="list-item-muted">{{ item.pr_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.wh_description }}</p>
            <p class="list-item-muted">{{ item.pr_spec }}</p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ list2.length }}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import F2 from "@antv/f2/lib/index";
import MixedInventoryAging from "@/components/field/MixedInventoryAging.vue";
import ProductField from "@/components/field/ProductField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
    MixedInventoryAging,
    ProductField,
    DepartmentField,
    EmployeeField,
  },
  data() {
    return {
      result: {},
      list2: [], // 库存账龄表列表
      selected: "库存账龄分析",
      opened: -1,
      chart: null,
      condition: null,
      querytype: "全部",
      querytypeObj: {
        全部: "all",
        物料类别: "prodtype",
        部门: "dept",
        业务员: "empl",
      },
      con: "全部",
      form: {
        pr_kind: null,
        dp_name: null,
        em_name: null,
      },
      textArr: [
        "1个月",
        "2个月",
        "3个月",
        "4个月",
        "5个月",
        "6个月",
        "7个月",
        "8个月",
        "9个月",
        "10个月",
        "11个月",
        "12个月",
        "1~2年",
        "2~3年",
        "3年以上",
      ],
    };
  },
  mounted() {
    this.searchBatchAgeAnalysis();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    clear() {
      this.form = {
        pr_detail: null,
        dp_name: null,
        em_name: null,
      };
    },
    onSelectProduct(selection) {
      this.form.pr_detail = selection.pr_detail;
      this.condition = "pr_id = " + selection.id;
      this.searchBatchAgeAnalysis();
    },
    onselectSeller(selection) {
      this.form.em_name = selection.em_name;
      this.condition = "em_id =" + selection.id;
      this.searchBatchAgeAnalysis();
    },
    onSelectDepartment(selection) {
      this.form.dp_name = selection.dp_name;
      this.condition = "dp_id = " + selection.id;
      this.searchBatchAgeAnalysis();
    },
    searchText() {
      this.clear();
      this.condition = null;
      this.searchBatchAgeAnalysis();
    },
    searchBatchAgeAnalysis() {
      let me = this,
        condition = me.condition,
        querytype = me.querytypeObj[me.querytype];
      let params = {
        mode: querytype,
        condition: condition
          ? JSON.stringify([{ type: "condition", value: condition }])
          : null,
      };

      me.$ajax({
        url: "/api/storage/report/batchAgeAnalysis",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    searchPurcsale() {
      let me = this;

      let searchBar = me.$refs.searchBar;
      let keyword = searchBar.keyword;

      let params = {
        number: 1,
        size: 99999,
        mode: "DETAIL",
        condition: [],
        page: 1,
        start: 0,
        limit: 99999,
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value: `(upper(pr_orispeccode) like '%${keyword}%' or upper(pr_code) like '%${keyword}%' or upper(pr_detail) like '%${keyword}%')`,
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/storage/report/inventoryAging",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list.list;
        }
      });
    },
    open(index) {
      if (index != this.opened) {
        this.initChart(this.deal2(this.result.details[index]));
      }
      this.opened = index == this.opened ? -1 : index;
    },
    deal2(data) {
      let me = this;
      if (!data) return;

      let arr = [];

      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: me.textArr[i],
          type: "金额",
          value: data["amount" + (i + 1)] || 0,
        });
      }
      // 处理1~2年（13-24个月）
      arr.push({
        index: 12,
        text: me.textArr[12], // "1~2年"
        type: "金额",
        value: data["amount24"] || 0,
      });

      // 处理2~3年（25-36个月）
      arr.push({
        index: 13,
        text: me.textArr[13], // "2~3年"
        type: "金额",
        value: data["amount36"] || 0,
      });

      // 处理3年以上（37个月以上）
      arr.push({
        index: 14,
        text: me.textArr[14], // "3年以上"
        type: "金额",
        value: data["amount99"] || 0,
      });
      return arr;
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 16 : 6,
          formatter: function (i) {
            const textArr = [
              "1个月",
              "2个月",
              "3个月",
              "4个月",
              "5个月",
              "6个月",
              "7个月",
              "8个月",
              "9个月",
              "10个月",
              "11个月",
              "12个月",
              "1~2年",
              "2~3年",
              "3年以上",
            ];
            return textArr[i];
          },
        },
      });
      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 16, type: "金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push({
          text: item.text,
          type: "金额",
          index: i,
          value: item.amount,
        });
      });

      return arr;
    },
    toggle(val) {
      this.selected = val;

      if (val == "库存账龄表") {
        this.searchPurcsale();
      }
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}

.list-empty {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}

.filter-row {
  width: 100%;
  padding: 1px 0px;
  background: #fff;
  /* height: 70px; */
}
.filter-info {
  /* height: 58px; */
  background-color: #fff;
  margin: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid var(--weui-FG-3);
}

.filter-select {
  width: 110px;
}
.filter-input {
  flex: 1;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
  width: 100%;
}
.list-fixed {
  width: 70px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex: 1;
  overflow-y: scroll;
}
.list-scroll-wrap {
  width: 640px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  width: 110px;
  font-size: 14px;
  font-weight: bold;
}
.list-fixed > .list-box-col__title {
  width: 100%;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 0px 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-container {
    line-height: 25px;
  }
  .filter-row {
    display: none;
  }
}
</style>